import {
  Category,
  ISubCategory,
  ManagementCategories,
  TLabeledItem,
} from "../types/types";

export const managementCategories: Record<ManagementCategories, ISubCategory> =
  {
    [ManagementCategories.Faq]: {
      value: ManagementCategories.Faq,
      title: "MANAGEMENT_FAQ",
    },
    [ManagementCategories.Card]: {
      value: ManagementCategories.Card,
      title: "MANAGEMENT_CARD",
    },
    [ManagementCategories.Invoices]: {
      value: ManagementCategories.Invoices,
      title: "MANAGEMENT_INVOICES",
    },
    [ManagementCategories.Settings]: {
      value: ManagementCategories.Settings,
      title: "MANAGEMENT_SETTINGS",
    },
    [ManagementCategories.Plans]: {
      value: ManagementCategories.Plans,
      title: "MANAGEMENT_PLANS",
    },
  };

export const menuCategories: Record<Category, string> = {
  [Category.Main]: "MENU_HOME",
  [Category.Support]: "MENU_SUPPORT",
  [Category.Profile]: "MENU_PROFILE",
  [Category.Library]: "MENU_LIBRARY",
  [Category.VenchiMarketplace]: "MENU_VENCHI_MARKETPLACE",
  [Category.Forum]: "MENU_FORUM",
  [Category.Users]: "MENU_USERS",
  [Category.Protocols]: "MENU_PROTOCOLS",
  [Category.Dashboards]: "MENU_DASHBOARDS",
  [Category.Reports]: "MENU_REPORTS",
  [Category.ClinicSummary]: "MENU_CLINIC_SUMMARY",
  [Category.Management]: "MENU_MANAGEMENT",
  [Category.videoDiagnostics]: "MENU_VIDEO_DIAGNOSTICS",
  [Category.Appointments]: "MENU_APPOINTMENTS",
  [Category.TutorialManagement]: "MENU_TUTORIAL_MANAGEMENT",
};

export const protocolCategories: TLabeledItem[] = [
  { value: "questionnaires", label: "PROTOCOL_QUESTIONNAIRES" },
  { value: "RRM", label: "PROTOCOL_RRM" },
  { value: "generalRRM", label: "PROTOCOL_GENERAL_RRM" },
  { value: "protocols", label: "PROTOCOL_PROTOCOLS" },
  { value: "sms", label: "PROTOCOL_SMS" },
  { value: "components", label: "PROTOCOL_COMPONENT_TYPES" },
];

export const userCategories: TLabeledItem[] = [
  { value: "clients", label: "USER_CLIENTS" },
  { value: "therapists", label: "USER_THERAPISTS" },
];

export const userCategoriesWithFakeCompanyId: TLabeledItem[] = [
  { value: "clients", label: "USER_CLIENTS" },
];

export interface IContactUsTheme {
  title: string;
  text: string;
}
